@if (isCurrentUserSuperAdmin()) {

@if (isLoading()) {
  <app-loader [overlay]="true" size="md" message="Loading roles…" />
}

<app-page-header title="Role Management"/>

<app-notification-dialog
  [visible]="isNotificationVisible()"
  [message]="notificationMessage()"
  [type]="notificationType()"
  (closed)="isNotificationVisible.set(false)" />

<main id="main-content" aria-labelledby="role-management-title"
  class="flex flex-col xl:flex-row gap-8 px-6 py-8 md:py-6 bg-main-bg min-h-[calc(100vh-200px)] max-w-[1600px] mx-auto w-full">
  <div class="xl:flex-[2] flex flex-col gap-8">
    <app-data-table title="Role List" [columns]="tableColumns" [data]="paginatedRoles()" trackByKey="id"
      [selectedItem]="selectedRole()" selectedKey="id" [currentPage]="currentPage()" [totalPages]="totalPages()"
      [totalItems]="filteredRoles().length" [pageSize]="pageSize" itemLabel="roles"
      (rowClick)="onSelectRole($event)" (deleteClick)="onDeleteRole($event)" (pageChange)="onPageChange($event)">
      <ng-template #cellTemplate let-item let-column="column">
        @switch (column) {

        @case ('roleName') {
          <div class="block w-full truncate whitespace-nowrap text-[12px] font-bold text-slate-700" [attr.title]="item.roleName">
            {{ item.roleName }}
          </div>
        }

        @case ('roleDescription') {
          <span class="block w-full truncate whitespace-nowrap text-[12px] font-medium text-slate-500"
            [attr.title]="item.roleDescription">
            {{ item.roleDescription }}
          </span>
        }

        @case ('active') {
          <div class="flex items-center justify-center gap-2">
            <span
              class="text-[11px] font-bold uppercase"
              [class]="item.active === 'Yes' ? 'text-emerald-600' : 'text-slate-600'">
              {{ item.active }}
            </span>
          </div>
        }

        }
      </ng-template>
    </app-data-table>
  </div>

  <div
    class="xl:flex-[2] xl:self-start bg-white rounded-2xl shadow-sm border border-slate-500 flex flex-col overflow-hidden w-full max-w-full lg:max-w-2xl xl:max-w-none mx-auto">
    <div
      class="px-8 py-2 border-b border-slate-400 flex flex-col sm:flex-row sm:items-center justify-between gap-4 bg-[#f8fafc]">
      <div>
        <h2 class="text-[18px] font-bold text-slate-800">Maintain Role</h2>
      </div>

      <div class="flex items-center gap-3">
        <app-button label="Add Role" ariaLabel="Add New Role" [disabled]="isEditRole()"
          (clicked)="onCreateRole()">
          <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5" d="M12 4v16m8-8H4" />
          </svg>
        </app-button>

        @if (selectedRole() || isAddRole()) {
        <app-button label="Edit Role" ariaLabel="Edit Role" [disabled]="isEditRole()" (clicked)="onEditRole()">
          <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5"
              d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
          </svg>
        </app-button>
        }
      </div>
    </div>

    @if (selectedRole() || isAddRole()) {

    <div class="flex-1 overflow-y-auto px-8 py-8 space-y-5 transition-opacity" [class.opacity-80]="!isEditRole()"
      [class.pointer-events-none]="!isEditRole()" (keydown)="onFormKeydown($event)">
      
      <section>
        <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div [class.pointer-events-auto]="!isEditRole()" [attr.title]="!isEditRole() ? roleName() : null">
            <label for="form-role-name" class="block text-[12px] font-bold mb-2 transition-colors"
              [class]="isEditRole() ? 'text-slate-900' : 'text-slate-700'">Role Name <span class="text-red-500"
                aria-hidden="true">*</span></label>
            <input id="form-role-name" type="text" [ngModel]="roleName()" (ngModelChange)="roleName.set($event)"
              [disabled]="!isEditRole()" aria-label="Role Name" required aria-required="true"
              maxlength="100"
              [class.pointer-events-none]="!isEditRole()"
              class="w-full px-4 py-1 text-[13px] border rounded-xl bg-slate-50/30 focus:outline-none focus:border-primary focus:ring-4 focus:ring-primary/5 transition-all outline-none placeholder:text-slate-600 disabled:bg-slate-100/50 disabled:text-slate-500 disabled:cursor-default"
              [class]="isEditRole() ? 'border-slate-500' : 'border-slate-300'" />
          </div>

          <div>
            <label class="block text-[12px] font-bold mb-6 transition-colors"
              [class]="isEditRole() ? 'text-slate-900' : 'text-slate-700'"></label>
            <label class="flex items-center justify-between p-4 py-1 rounded-xl border bg-slate-50/30 transition-colors h-[34px]"
              [class]="isEditRole() ? 'border-slate-500 cursor-pointer' : 'border-slate-300 cursor-default'">
              <span class="text-[12px] font-bold transition-colors"
                [class]="isEditRole() ? 'text-slate-900' : 'text-slate-800'">Active</span>
              <span class="relative inline-flex items-center">
                <input type="checkbox" [ngModel]="isActive()" (ngModelChange)="isActive.set($event)"
                  [disabled]="!isEditRole()" class="sr-only peer" aria-label="Active Status" />
                <span
                  class="w-11 h-6 bg-slate-200 peer-focus:outline-none rounded-full peer peer-checked:after:translate-x-full after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-primary shadow-inner">
                </span>
              </span>
            </label>
          </div>
        </div>
      </section>

      <section>
        <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div>
            <label for="form-role-description" class="block text-[12px] font-bold mb-2 transition-colors"
              [class]="isEditRole() ? 'text-slate-900' : 'text-slate-700'">Role Description</label>
            <textarea #descriptionInput id="form-role-description" [ngModel]="roleDescription()" (ngModelChange)="roleDescription.set($event)"
              [disabled]="!isEditRole()" aria-label="Role Description" rows="3"
              maxlength="500"
              class="w-full px-4 py-2 text-[13px] border rounded-xl bg-slate-50/30 focus:outline-none focus:border-primary focus:ring-4 focus:ring-primary/5 transition-all outline-none placeholder:text-slate-600 disabled:bg-slate-100/50 disabled:text-slate-500 disabled:cursor-default resize-y hover:shadow-md"
              [class]="isEditRole() ? 'border-slate-500' : 'border-slate-300'"
              style="min-height: 76px;"></textarea>
          </div>

          <div>
            <label class="block text-[12px] font-bold mb-2 transition-colors"
              [class]="isEditRole() ? 'text-slate-900' : 'text-slate-700'">Reports Permissions</label>
            <div class="mt-[10px]">
              <label class="flex items-center justify-between p-3 rounded-lg border bg-white transition-colors"
                [class]="isEditRole() ? 'border-slate-700 cursor-pointer' : 'border-slate-200 cursor-default'">
                <span class="text-[12px] font-medium transition-colors"
                  [class]="isEditRole() ? 'text-slate-900' : 'text-slate-700'">View Reports</span>
                <span class="relative inline-flex items-center">
                  <input type="checkbox" [ngModel]="reportsView()" (ngModelChange)="reportsView.set($event)"
                    [disabled]="!isEditRole()" class="sr-only peer" aria-label="View Reports Permission" />
                  <span
                    class="w-9 h-5 bg-slate-200 peer-focus:outline-none rounded-full peer peer-checked:after:translate-x-full after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:rounded-full after:h-4 after:w-4 after:transition-all peer-checked:bg-primary shadow-inner">
                  </span>
                </span>
              </label>
            </div>
          </div>
        </div>
      </section>

      <section>
        <label class="block text-[12px] font-bold mb-2 transition-colors"
              [class]="isEditRole() ? 'text-slate-900' : 'text-slate-700'">Knowledge Base Permissions</label>
          
        <div class="border border-slate-300 rounded-xl p-4 bg-slate-50/20">
          <div class="grid grid-cols-1 md:grid-cols-2 gap-3 mb-3">
            <label class="flex items-center justify-between p-3 rounded-lg border bg-white transition-colors"
              [class]="isEditRole() ? 'border-slate-300 cursor-pointer' : 'border-slate-200 cursor-default'">
              <span class="text-[12px] font-medium transition-colors"
                [class]="isEditRole() ? 'text-slate-900' : 'text-slate-700'">View KB</span>
              <span class="relative inline-flex items-center">
                <input type="checkbox" [ngModel]="viewKB()" (ngModelChange)="viewKB.set($event)"
                  [disabled]="!isEditRole() || manageKB()" class="sr-only peer" aria-label="Knowledge Base View Permission" />
                <span
                  class="w-9 h-5 bg-slate-200 peer-focus:outline-none rounded-full peer peer-checked:after:translate-x-full after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:rounded-full after:h-4 after:w-4 after:transition-all peer-checked:bg-primary shadow-inner">
                </span>
              </span>
            </label>

            <label class="flex items-center justify-between p-3 rounded-lg border bg-white transition-colors"
              [class]="isEditRole() ? 'border-slate-300 cursor-pointer' : 'border-slate-200 cursor-default'">
              <span class="text-[12px] font-medium transition-colors"
                [class]="isEditRole() ? 'text-slate-900' : 'text-slate-700'">Manage KB</span>
              <span class="relative inline-flex items-center">
                <input type="checkbox" [ngModel]="manageKB()" (ngModelChange)="onManageKBChange($event)"
                  [disabled]="!isEditRole()" class="sr-only peer" aria-label="Knowledge Base Manage Permission" />
                <span
                  class="w-9 h-5 bg-slate-200 peer-focus:outline-none rounded-full peer peer-checked:after:translate-x-full after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:rounded-full after:h-4 after:w-4 after:transition-all peer-checked:bg-primary shadow-inner">
                </span>
              </span>
            </label>
          </div>

          <!-- <div class="grid grid-cols-1 md:grid-cols-2 gap-3">
            <label class="flex items-center justify-between p-3 rounded-lg border bg-white transition-colors"
              [class]="isEditRole() ? 'border-slate-300 cursor-pointer' : 'border-slate-200 cursor-default'">
              <span class="text-[12px] font-medium transition-colors"
                [class]="isEditRole() ? 'text-slate-900' : 'text-slate-700'">Update</span>
              <span class="relative inline-flex items-center">
                <input type="checkbox" [ngModel]="knowledgeBaseUpdate()" (ngModelChange)="knowledgeBaseUpdate.set($event)"
                  [disabled]="!isEditRole()" class="sr-only peer" aria-label="Knowledge Base Update Permission" />
                <span
                  class="w-9 h-5 bg-slate-200 peer-focus:outline-none rounded-full peer peer-checked:after:translate-x-full after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:rounded-full after:h-4 after:w-4 after:transition-all peer-checked:bg-primary shadow-inner">
                </span>
              </span>
            </label>

            <label class="flex items-center justify-between p-3 rounded-lg border bg-white transition-colors"
              [class]="isEditRole() ? 'border-slate-300 cursor-pointer' : 'border-slate-200 cursor-default'">
              <span class="text-[12px] font-medium transition-colors"
                [class]="isEditRole() ? 'text-slate-900' : 'text-slate-700'">Delete</span>
              <span class="relative inline-flex items-center">
                <input type="checkbox" [ngModel]="knowledgeBaseDelete()" (ngModelChange)="knowledgeBaseDelete.set($event)"
                  [disabled]="!isEditRole()" class="sr-only peer" aria-label="Knowledge Base Delete Permission" />
                <span
                  class="w-9 h-5 bg-slate-200 peer-focus:outline-none rounded-full peer peer-checked:after:translate-x-full after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:rounded-full after:h-4 after:w-4 after:transition-all peer-checked:bg-primary shadow-inner">
                </span>
              </span>
            </label>
          </div> -->
        </div>

        @if (!hasAtLeastOnePermission() && isEditRole()) {
        <p class="text-[11px] font-bold text-red-500 mt-2 ml-1 animate-in fade-in slide-in-from-top-1 duration-200">
          At least one permission must be selected
        </p>
        }
      </section>
    </div>

    @if (isEditRole()) {
    <div class="px-10 py-2 border-t border-slate-300 flex items-center justify-end gap-3 bg-slate-50/10">
      <app-button label="Cancel" (clicked)="onCancel()" />
      <app-button label="Save" [disabled]="!isFormValid()" (clicked)="onSave()" />
    </div>
    }
    }
  </div>
</main>
} @else {
<div class="flex items-center justify-center min-h-[calc(100vh-200px)]">
  <div class="text-center p-12 bg-white rounded-3xl shadow-xl border border-slate-300 max-w-md">
    <div class="w-20 h-20 bg-red-50 text-red-500 rounded-full flex items-center justify-center mx-auto mb-6">
      <svg class="w-10 h-10" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
          d="M12 15v2m0-6V9m0 12a9 9 0 110-18 9 9 0 010 18z" />
      </svg>
    </div>
    <h2 class="text-2xl font-black text-slate-800 mb-4">Access Denied</h2>
    <p class="text-slate-600 font-medium leading-relaxed mb-8">
      This screen is restricted to Super Admins only. Please contact your system administrator if you believe this is an
      error.
    </p>
    <button onclick="window.history.back()"
      class="px-6 py-2.5 bg-gradient-primary text-white text-[13px] font-bold rounded-xl hover:scale-105 transition-all shadow-md active:scale-95">
      Go Back
    </button>
  </div>
</div>
}

<app-confirm-dialog [visible]="showDeleteModal()"
  [message]="'Are you sure you want to delete role: ' + (roleToDelete()?.roleName || '') + '? This role cannot be deleted if it is assigned to users.'"
  (confirmed)="confirmDelete()" (cancelled)="cancelDelete()" />